import { DC, DCSetting } from '../importers/interfaces'
import Excludable from './shared/Excludable'

/**
 * Distributed clock
 */
export class DistributedClock extends Excludable {
  public assignActivate = '#x300'

  public cycleTS0 = new DistributedClockSetting({
    value: 0,
    factor: 1,
    factorDefault: 1,
  })

  public cycleTS1 = new DistributedClockSetting({
    value: 0,
    factor: 0,
    included: false,
  })

  public shiftTS0 = new DistributedClockSetting({
    value: 0,
    factor: -2,
    factorDefault: -2,
  })

  public shiftTS1 = new DistributedClockSetting({
    value: 0,
    factor: 0,
    included: false,
  })

  public included = false

  constructor(data: DC | null = null) {
    super({})
    this.included = data?.included ?? false

    if (data) {
      this.assignActivate = data.assignActivate

      this.cycleTS0 = this.cycleTS0.processData(data.cycleTS0)
      this.cycleTS1 = this.cycleTS1.processData(data.cycleTS1)
      this.shiftTS0 = this.shiftTS0.processData(data.shiftTS0)
      this.shiftTS1 = this.shiftTS1.processData(data.shiftTS1)
    }
  }
}

export class DistributedClockOpMode extends DistributedClock {
  public name: string
  public description: string

  constructor(data: DC & { name: string; description: string }) {
    super(data)

    this.name = data.name
    this.description = data.description
  }
}

/**
 * Distributed clock setting
 */
export class DistributedClockSetting extends Excludable {
  public value = 0
  public factor = 0
  public factorDefault = 0
  public mode = DistributedClockSettingMode.CYCLE
  public included = true

  constructor(data: DCSetting | null = null) {
    super({})

    this.factorDefault = data?.factorDefault ?? 0

    if (data) {
      this.processData(data)
    }
  }

  processData(data: DCSetting) {
    this.included = data?.included ?? (this.value !== data?.value || this.included)
    this.value = data.value
    this.factor = data.factor ?? 0
    this.mode = !data.factor //
      ? DistributedClockSettingMode.USER_DEFINED
      : DistributedClockSettingMode.CYCLE

    return this
  }
}

/**
 * Distributed clock setting mode
 */
export enum DistributedClockSettingMode {
  CYCLE,
  USER_DEFINED,
}

export namespace DistributedClockSettingMode {
  export function list() {
    return [
      {
        name: 'Cycle',
        value: DistributedClockSettingMode.CYCLE,
      },
      {
        name: 'User Defined',
        value: DistributedClockSettingMode.USER_DEFINED,
      },
    ]
  }
}
